import {LogDto} from '../../model/LogDto';
import {DataHubService} from "../../modules/DataHubModule";

export default class LogController {
    logs: LogDto[];

    $onInit(): void {
        this.reload();
    }
    constructor(private $dataHub: DataHubService) {
        $dataHub.bindAllLog(() => this.logs);
        $dataHub.onConnected(this.reload);
    }

    reload = () => {
        this.logs = [];
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.server.logSubscribe();
    }

    getRows = (log:LogDto) => {
        return Math.min(10, log.messageLines);
    }
}
